var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"oss-image",style:({ width: _vm.width, height: _vm.height })},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgUrl),expression:"imgUrl"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }